import { MathUtils3D } from "./MathUtils3D";
export class Vector2 {
    constructor(x = 0, y = 0) {
        this.x = x;
        this.y = y;
    }
    setValue(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    static scale(a, b, out) {
        out.x = a.x * b;
        out.y = a.y * b;
    }
    static equals(a, b) {
        return MathUtils3D.nearEqual(a.x, b.x) && MathUtils3D.nearEqual(a.y, b.y);
    }
    fromArray(array, offset = 0) {
        this.x = array[offset + 0];
        this.y = array[offset + 1];
    }
    toArray() {
        return [this.x, this.y];
    }
    writeTo(array, offset = 0) {
        array[offset + 0] = this.x;
        array[offset + 1] = this.y;
    }
    cloneTo(destObject) {
        destObject.x = this.x;
        destObject.y = this.y;
        return destObject;
    }
    static dot(a, b) {
        return (a.x * b.x) + (a.y * b.y);
    }
    static normalize(s, out) {
        var x = s.x, y = s.y;
        var len = x * x + y * y;
        if (len > 0) {
            len = 1 / Math.sqrt(len);
            out.x = x * len;
            out.y = y * len;
        }
    }
    static scalarLength(a) {
        var x = a.x, y = a.y;
        return Math.sqrt(x * x + y * y);
    }
    static distance(a, b) {
        let x = a.x - b.x;
        let y = a.y - b.y;
        return Math.sqrt(x * x + y * y);
    }
    clone() {
        var destVector2 = new Vector2();
        this.cloneTo(destVector2);
        return destVector2;
    }
}
Vector2.ZERO = new Vector2(0.0, 0.0);
Vector2.ONE = new Vector2(1.0, 1.0);
Vector2.TEMP = new Vector2();
